import css from 'styled-jsx/css';
import { colors } from '../../themes';

export default css`
  .snippet-modal {
    display: flex;
    cursor: pointer;
    padding-bottom: 5px;
    margin-bottom: 10px;
    text-decoration: none;
    width: 100%;
  }

  h2 {
    color: ${colors.blue};
    font-size: 0.86rem;
  }

  .currency {
    color: ${colors.black};
    display: block;
    font-size: 0.86rem;
    margin-top: 5px;
  }

  .icon-wrapper {
    background: ${colors.grayExtraLight};
    color: ${colors.grayLight};
    display: block;
    height: 100%;
    width: 100%;
  }

  .img-wrapper {
    flex-basis: 20%;
  }

  .text-wrapper {
    flex-basis: 80%;
    padding-left: 10px;
  }
`;



// WEBPACK FOOTER //
// ./app/common/SnippetModal/styles.js